import businessStates from './businessStates';
import contractStates from './contractStates';
import reconciliationStates from './reconciliationStates';
import theftRecoveryRequestStates from './theftRecoveryRequestStates';
import saleLocatorTypes from './saleLocatorTypes';
import resetRequestStates from './resetRequestStates';
import { LOCATOR_ALERTS, HEARTBEAT_INTERVALS, DEFAULT_HEARTBEAT_INTERVAL } from './locatorAlerts';
const LOG_TYPES = {
  MANUFACTURING: 'manufacturing',
  SHIPMENT: 'shipment',
  ARCHIVE: 'archive'
};
const SKU_TYPES = {
  LOCATOR: 'locator',
  BEACON: 'beacon',
  GATEWAY: 'gateway',
  TAG: 'tag'
};
const LOCATOR_SKUS = [{
  name: 'HW1868-1.0',
  value: 'HW1868-1.0'
}, {
  name: 'HW1868-1.1',
  value: 'HW1868-1.1'
}, {
  name: 'HW1868-1.2',
  value: 'HW1868-1.2'
}, {
  name: 'HW1868-2.0',
  value: 'HW1868-2.0'
}, {
  name: 'HW1868-2.1',
  value: 'HW1868-2.1'
}, {
  name: 'HW1868-3.0',
  value: 'HW1868-3.0'
}, {
  name: 'HW1868-3.1',
  value: 'HW1868-3.1'
}, {
  name: 'HW1868-3.2',
  value: 'HW1868-3.2'
}, {
  name: 'HW1868-3.3',
  value: 'HW1868-3.3'
}, {
  name: 'HW1910-1.1',
  value: 'HW1910-1.1'
}, {
  name: 'HW1910-3.4',
  value: 'HW1910-3.4'
}, {
  name: 'HW1915-1.0',
  value: 'HW1915-1.0'
}];
const BEACON_SKUS = [{
  name: 'HW1869-1.0',
  value: 'HW1869-1.0'
}];
const DEFAULT_TAG_SKU = {
  name: 'HW1895-1.0',
  value: 'HW1895-1.0',
  model: 'HW1895',
  revision: '1.0'
};
const LOCATION_TYPES = {
  DEALERSHIP: 'dealership',
  CONSUMER: 'consumer',
  MANUFACTURING: 'manufacturing',
  RECONDITIONED: 'reconditioned'
};
const RECOVR_HOTLINE_NUMBER = '+1 888-306-7166';
const ONE_HOUR_IN_MS = 60 * 60 * 1000;
const SKU_BLUEPRINT_MAP = {
  'HW1868-1.0': 'locator',
  'HW1868-1.1': 'locator',
  'HW1868-1.2': 'locator',
  'HW1868-2.0': 'locator',
  'HW1868-2.1': 'locator',
  'HW1868-3.0': 'locator',
  'HW1868-3.1': 'locator',
  'HW1868-3.2': 'locator',
  'HW1868-3.3': 'locator',
  'HW1910-1.1': 'locator',
  'HW1910-3.4': 'locator',
  'HW1915-1.0': 'locator',
  'HW1869-1.0': 'beacon',
  'HW1868-1.0-RG': 'gateway',
  'HW1868-1.1-RG': 'gateway',
  'HW1868-1.2-RG': 'gateway',
  'HW1868-2.0-RG': 'gateway',
  'HW1868-2.1-RG': 'gateway',
  'HW1868-3.0-RG': 'gateway',
  'HW1868-3.1-RG': 'gateway',
  'HW1868-3.2-RG': 'gateway',
  'HW1868-3.3-RG': 'gateway',
  'HW1872-1.0': 'gateway',
  'HW1872-2.0': 'gateway',
  'HW1895-1.0': 'tag'
};
const FIRMWARE_STATES = {
  UP_TO_DATE: 'up-to-date',
  PENDING: 'pending',
  FAILED: 'failed'
};
const UNPAIRED = '___UNPAIRED___';
const COMPANY_VAS = {
  CADA: 'cADA',
  NO_VAS: 'noVas',
  CALIFORNIA_SALES: 'californiaSales',
  TAG: 'tag',
  JMA: 'jMandA'
};
const VEHICLE_SALE_STATES = {
  AVAILABLE: 'available',
  PENDING: 'pendingRemoveLocator',
  PENDING_REMOVE_LOCATOR: 'pendingRemoveLocator',
  PENDING_REPLACE_LOCATOR: 'pendingReplaceLocator',
  PENDING_ADD_LOCATOR: 'pendingAddLocator',
  SOLD: 'sold'
};
const ACTIONS_TYPE = {
  ITEM: 'imagine.ItemDelegate',
  GROUP: 'imagine.GroupDelegate'
};
export default {
  businessStates,
  contractStates,
  reconciliationStates,
  theftRecoveryRequestStates,
  saleLocatorTypes,
  resetRequestStates,
  LOG_TYPES,
  SKU_TYPES,
  LOCATOR_SKUS,
  BEACON_SKUS,
  LOCATION_TYPES,
  RECOVR_HOTLINE_NUMBER,
  ONE_HOUR_IN_MS
};
export { businessStates, contractStates, reconciliationStates, theftRecoveryRequestStates, resetRequestStates, LOG_TYPES, SKU_TYPES, LOCATOR_SKUS, BEACON_SKUS, LOCATION_TYPES, RECOVR_HOTLINE_NUMBER, ONE_HOUR_IN_MS, SKU_BLUEPRINT_MAP, FIRMWARE_STATES, DEFAULT_TAG_SKU, UNPAIRED, COMPANY_VAS, LOCATOR_ALERTS, VEHICLE_SALE_STATES, HEARTBEAT_INTERVALS, DEFAULT_HEARTBEAT_INTERVAL, ACTIONS_TYPE };